import React, { Fragment } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, bool } from 'prop-types'

function Layout({
  heading = null,
  content = null,
  action = null,
  useWideContent = false,
}) {
  return (
    <Fragment>
      <div className="new-banner__heading">
        { heading }
      </div>
      <div
        className={classnames(
          'new-banner__content',
          useWideContent && 'new-banner__content--wide'
        )}
      >
        { content }
      </div>
      { action }
    </Fragment>
  )
}

Layout.propTypes = {
  heading: node,
  content: node,
  action: node,
  useWideContent: bool,
}

export default Layout
